module.exports = __webpack_public_path__ + "img/img-empty-state-c-custo.0afcafd7.svg";